import { combineReducers } from "redux";
import {
    UserManagerV4TableDataWidget,
    AddUserV4Widget
} from "../../../widgets";
import { SET_TAB_SELECTION, GET_USER_TYPES } from "./types";
const INITIAL_STATE = {
    tab: "admin",
    user_types: false,
    requesting: false
};
const mainReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_TAB_SELECTION: {
            return { ...state, tab: action.payload };
        }
        case GET_USER_TYPES.REQUEST: {
            return { ...state, requesting: true, user_types: false };
        }
        case GET_USER_TYPES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                user_types: action.payload
            };
        }
        case GET_USER_TYPES.FAIL: {
            return { ...state, requesting: false, user_types: false };
        }
        default: {
            return { ...state };
        }
    }
};
export default combineReducers({
    [UserManagerV4TableDataWidget.reducer_key]:
        UserManagerV4TableDataWidget.reducer,
    [AddUserV4Widget.reducer_key]: AddUserV4Widget.reducer,
    mainReducer
});
